// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__BrSGe","logoContainer":"LinkedLogo_logoContainer__nciU0","betaFlagContainer":"LinkedLogo_betaFlagContainer__cEHMe","betaFlag":"LinkedLogo_betaFlag__bTivG"};